import React from 'react';
import Note from "./Note";
var defaultProps = {
  className: '',
  notes: []
};

var Notes = function Notes(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? defaultProps.className : _ref$className,
      _ref$notes = _ref.notes,
      notes = _ref$notes === void 0 ? defaultProps.notes : _ref$notes,
      children = _ref.children,
      onCancel = _ref.onCancel,
      onChange = _ref.onChange,
      onDelete = _ref.onDelete,
      onEdit = _ref.onEdit,
      onSave = _ref.onSave,
      onUndelete = _ref.onUndelete;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, children || notes.map(function (note) {
    return /*#__PURE__*/React.createElement(Note, {
      key: note.id ? "js-note-".concat(note.id) : undefined,
      note: note,
      onCancel: onCancel,
      onChange: onChange,
      onDelete: onDelete,
      onEdit: onEdit,
      onSave: onSave,
      onUndelete: onUndelete,
      saving: note.editing && note.saving
    });
  }));
};

Notes.displayName = "Notes";
Notes.displayName = 'Notes';
Notes.defaultProps = defaultProps;
export default Notes;